export const LogoMark = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
    <rect x="2" y="2" width="36" height="36" rx="8" fill="#A9B950" />
    <text
      x="20"
      y="27.5"
      fontFamily="'Cabinet Grotesk', sans-serif"
      fontWeight="800"
      fontSize="20"
      fill="#232B12"
      textAnchor="middle"
    >
      m
    </text>
  </svg>
);

export const Logo = ({ markSize = 30, textSize = "text-2xl", onDark = false }) => (
  <span className="flex items-center gap-2">
    <LogoMark size={markSize} />
    <span
      className={`font-heading font-bold tracking-tight ${textSize} ${onDark ? "text-white" : "text-ink"}`}
    >
      mnand
      <span className={onDark ? "text-tea" : "text-almond"}>i</span>
    </span>
  </span>
);
